<template>
  <div>
    <el-page-header
      content="Transfer instance to another project"
      @back="$emit('back')"
    />

    <p>
      Select a project to transfer your Cloud Server.
      You can <router-link to="/projects">manage them</router-link> and create unlimited projects.
    </p>

    <el-row :gutter="20">
      <el-col v-for="role in roles" :key="role.id" :span="12">
        <AccountProject
          :role="role"
          :show-product="false"
          label="Transfer to this project"
          @click="transfer"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccountProject from '../Account/Project'

export default {
  props: {
    plan: Object,
    instance: Object
  },
  components: {
    AccountProject
  },
  data () {
    return {
    }
  },
  computed: {
    roles () {
      return (this.user.roles || []).filter((r) => r.project.clientId === this.client.id)
    },
    ...mapState(['user', 'client'])
  },
  methods: {
    transfer (roleId) {
      const role = this.roles.find((r) => r.id === roleId)
      if (!role) {
        return
      }

      const msg = 'Once you transfer, team access will be updated. To confirm, please enter TRANSFER below.'
      const payload = { ...this.instance }
      payload.transferId = role.project.id

      this.$prompt(msg, 'Cloud Server Transfer', {
        confirmButtonText: 'Transfer',
        cancelButtonText: 'Cancel',
        inputValidator: (value) => value === 'TRANSFER',
        inputErrorMessage: 'Invalid input'
      }).then(() => this.$store.dispatch('transferInstance', payload))
        .then(() => this.$router.push('/?roleId=' + roleId))
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-row {
    margin-top: 30px;
  }
</style>
